import './ContactForm.scss';

import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { Formik } from 'formik';

const ContactForm = () => {
  const { t } = useTranslation();
  const initialValues = {
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    message: ''
  };
  return (
    <div className="contact-form">
      <h4 className="contact-form__title">{t('Contact.4')}</h4>
      <Formik 
      initialValues={{...initialValues}}
      validationSchema={Yup.object().shape({
        firstname:Yup.string().required('Firstname is required'),
        lastname:Yup.string().required('Lastname is required'),
        email:Yup.string().email('Please enter valid e-mail').required('E-mail is required'),
        phone: Yup.string().required('Phone is required'),
        message:Yup.string().required('Subject is required')
      })}
      onSubmit={(values) => {
          console.log(values);
        }}>{
        ({errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          isValid,
          dirty,
          touched,
          values}) => 
          (
    <form  noValidate autoComplete='off' onSubmit={handleSubmit} className="contact-form__form">
        <div className="contact-form__input my-4 d-flex justify-content-center align-items-center">
          <input
          error={Boolean(touched.firstname && errors.firstname)}
          placeholder={touched.firstname && errors.fastname}
          label="Firstname"
          name='firstname'
          required
          onBlur={handleBlur}
          onChange={handleChange}
          className="contact-form__input-field"
          type="text"
          value={values.firstname}
          
          />
          <input
          required
          error={Boolean(touched.lastname && errors.lastname)}
          label="Lastname"
          name='lastname'
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.lastname}
          className="contact-form__input-field"
          type="text"
          placeholder={touched.lastname && errors.lastname}
          />
        </div>
        <div className="contact-form__input d-flex justify-content-center align-items-center">
          <input
          required
          label="Phone"
          name='phone'
          error={Boolean(touched.phone && errors.phone)}
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.phone}
          className="contact-form__input-field"
          type="text"
          placeholder={touched.phone && errors.phone}
          />
          <input
          label="Email"
          name='email'
          required
          error={Boolean(touched.email && errors.email)}
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.email}
          className="contact-form__input-field"
          type="email"
          placeholder={touched.email && errors.email}
          />
        </div>
        <div className="contact-form__message mt-4">
          <textarea
          label="Message"
          name='message'
          required
          error={Boolean(touched.message && errors.message)}
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.message}
          rows="10"
          className="contact-form__message"
          placeholder={touched.message && errors.message}
          ></textarea>
        </div>
        <button className="btn btn-danger" type="submit" disabled={Boolean(!isValid)} >
        {t('Contact.9')}
        </button>
      </form>
          )}
      </Formik>
    </div>
  );
};
export default ContactForm;